import { render, staticRenderFns } from "./SongsList.vue?vue&type=template&id=0fa2c429&"
import script from "./SongsList.vue?vue&type=script&lang=js&"
export * from "./SongsList.vue?vue&type=script&lang=js&"
import style0 from "./SongsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports